import React from 'react';

import { Drawer as DrawerRoot, DrawerClose, DrawerContent, DrawerHeader, DrawerTitle } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import Icon from '@/components/icons';

type DrawerProps = {
  anchor?: 'left' | 'right';
  ariaLabel?: string;
  ariaLabelledBy?: string;
  children?: React.ReactNode;
  closeAriaLabel?: string;
  isOpen?: boolean;
  onClose?: () => void;
};

const Drawer = ({
  anchor = 'left',
  ariaLabel,
  ariaLabelledBy,
  children,
  closeAriaLabel = 'Close',
  isOpen = false,
  onClose = () => {},
}: DrawerProps) => {
  return (
    <DrawerRoot
      direction={anchor}
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DrawerContent
        aria-describedby={undefined}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        className="px-6"
      >
        <DrawerHeader className="relative flex-row pl-0">
          {ariaLabelledBy && (
            <DrawerTitle id={ariaLabelledBy} className="sr-only">
              {ariaLabel ?? 'Drawer'}
            </DrawerTitle>
          )}
          <DrawerClose asChild>
            <Button
              size="sm"
              variant="ghost"
              aria-label={closeAriaLabel}
              className="[&_svg]:size-5 p-0 hover:bg-transparent cursor-pointer"
            >
              <Icon name="close" aria-hidden />
            </Button>
          </DrawerClose>
        </DrawerHeader>
        <div className="flex flex-col mt-4">{children}</div>
      </DrawerContent>
    </DrawerRoot>
  );
};

export { Drawer };
